import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import { AgriFieldList, Plantings, AgriFieldParam, File } from '@/types';
import List from '@/assets/common/List/List.vue';
import SelectPlanting from '@/components/SelectPlanting/SelectPlanting.vue';
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';
import moment from 'moment';
import { isAdmin } from '@/assets/common/services'
import store from '@/assets/common/store/store';


@Component({
    components: {
        List,
        SelectPlanting,
        Thumbnail
    }
})
export default class AgriFields extends Vue {
    private list: any = null
    private title = '圃場'
    private tableTitle = '圃場情報'
    private isVisible = true
    private agriFields:  AgriFieldList[] = []
    private agriFieldId = ''
    private agriFieldIdIsHidden = false
    private agriFieldName = ''
    private agriFieldArea = 0
    private agriFieldMemo = ''
    private agriFieldDisplayStart = ''
    private agriFieldDisplayEnd = ''
    private agriFieldPlantings: Plantings[] = []
    private agriFieldFileIds: string[] = []
    private selectedPlantings: Plantings[] = []
    private selectedPlantingIds: string[] = []
    private images: File[] = []
    private files: File[] = []
    private isLoading = false
    private isShowSelectPlanting = false
    private preSelectPlantingId: string[] = []
    private apiBaseUrl = '/agri_fields'
    private apiBaseAdminUrl = '/admin/agri_fields'
    private clientBaseUrl = '/master/agri-fields'
    private deletedFiles: File[] = []
    private withHidden = false;
    private isEditable = true

    @Prop()
    private id!: string

    private created() {
        this.getAgriFields()
        this.isEditable = isAdmin(this.$store.getters.loginUser)
    }

    private getAgriFields() {
        this.list = null
        this.isLoading = true
        this.$apiClient.doRequest('get', `${this.apiBaseUrl}?with_hidden=${this.withHidden}`).then((ret) => {
            this.agriFields = ret.agri_fields
        })
        .finally(() => {
            this.list = List
            this.isLoading = false
        })
    }

    private toggleHiddenItems(value: boolean) {
        this.withHidden = value;
        this.getAgriFields();        
    }

    private getFile(agriFieldId: string, fileId: string) {
        return  this.$apiClient.doRequest('get', `${this.apiBaseUrl}/${agriFieldId}/files/${fileId}`)
    }

    private getFiles(fileIds: string[]) {
        const promises: any = []
        fileIds.forEach(id => {
            promises.push(this.getFile(this.agriFieldId, id))
        })
        Promise.all(promises).then(ret => {
            ret.forEach((file: any) => {
                if(this.$apiClient.isImageFile(file.meta.name)) {
                    this.images.push(file)
                }else {
                    this.files.push(file)
                }
            })
        })
    }

    private setAgriField(itemId: string) {
       this.$router.push(this.clientBaseUrl + '/' + itemId, () => {return})
       if(store.getters.isInputChanged==false){
        this.tableTitle = '圃場情報'
        this.images = []
        this.files = []
        this.preSelectPlantingId = []
        this.$apiClient.doRequest('get', `${this.apiBaseUrl}/${itemId}`).then((ret) => {
            this.agriFieldId = ret.id
            this.agriFieldName = ret.name
            this.agriFieldArea = this.$apiClient.exponentToDecimal(ret.planted_area) as any
            this.agriFieldMemo = ret.memo
            this.agriFieldDisplayStart = ret.display_start
            this.agriFieldDisplayEnd = ret.display_end
            this.agriFieldPlantings = ret.plantings
            this.agriFieldFileIds = ret.file_id
            this.agriFieldIdIsHidden = ret.is_hidden

            this.getFiles(ret.file_id)

            if(ret.plantings) {
                ret.plantings.forEach((item: any) => {
                    this.preSelectPlantingId.push(item.id)
                })
            }
        })
        }
        
    }

    private dateFormat(date: Date) {
        const year = new Date(date).getFullYear()
        const month = new Date(date).getMonth() + 1
        return year + '年' + month + '月'
    }

    private onFileChange(e: any) {
        const files = e.target.files || e.dataTransfer.files;

        if(this.$apiClient.isSizeOver(files)) {
            return
        }

        if(this.$apiClient.isImageFile(files[0].name)) {
            this.$apiClient.getBase64(files[0]).then((image: any) => {
                const item = {
                    file: image.file,
                    url: image.base64
                } as File
                this.images.push(item)
            }).catch(() => {
                window.alert('画像ファイルが読み込めませんでした')
            })
        }else {
            const item = {
                file: files[0],
                url: '',
                meta: {
                    name: files[0].name
                }
            } as File
            this.files.push(item)
        }
        e.target.value = ''
        this.inputChanged()
    }

    private deleteImage(image: File, index: number) {
        this.images.splice(index, 1)
        if(image.id) {
            this.deletedFiles.push(image)
        }
    }

    private deleteFile(file: File, index: number) {
        this.files.splice(index, 1)
        if(file.id) {
            this.deletedFiles.push(file)
        }
    }

    private addAgriField() {
        this.$router.push(this.clientBaseUrl, () => {return})
       if(store.getters.isInputChanged==false){
        this.tableTitle = '新規圃場'
        this.agriFieldId = 'create'
        this.agriFieldName = ''
        this.agriFieldArea = 0
        this.agriFieldMemo = ''
        this.agriFieldDisplayStart = ''
        this.agriFieldDisplayEnd = ''
        this.agriFieldPlantings = []
        this.agriFieldIdIsHidden = false
        this.images = []
        this.files = []
        this.preSelectPlantingId = []
       } 
    }

    private addPlant() {
        this.isShowSelectPlanting = true
        this.inputChanged()
    }

    private setPlanting(plantings: any) {
        this.agriFieldPlantings = plantings as Plantings[]
        this.preSelectPlantingId = []
        plantings.forEach((item: any) => {
            this.preSelectPlantingId.push(item.id)
        })
    }

    private closeSelectPlantingModal() {
        this.isShowSelectPlanting = false
    }

    private switchDisplayAgriField() {        
        if (!window.confirm(`${this.agriFieldName}を${ this.agriFieldIdIsHidden? '表示状態に戻します' : '非表示にします' }。よろしいですか？`)){
            return
        }
        this.agriFieldIdIsHidden = !this.agriFieldIdIsHidden
        this.submit(true)
    }

    private cancelEdit() {
        if (this.$store.getters.isInputChanged) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);
        if(this.agriFieldId !== 'create') {
            this.setAgriField(this.agriFieldId)
        }else {
            this.addAgriField()
        }
    }

    private submit(isHiddenUpdate: boolean) {
        const errmsg: string[] = []
        // 名前の入力
        if(!this.agriFieldName.trim()) {
            errmsg.push("名前を入力してください")
        }
        // 名前の長さ
        if(this.agriFieldName.length > 100) {
            errmsg.push(`名前は100文字以内で入力してください（現在は${this.agriFieldName.length}文字）`)
        }
        // 面積
        if(!this.agriFieldArea?.toString() || this.agriFieldArea < 0) {
            errmsg.push("面積は0以上の値を入力してください")
        } else {
            // 面積の数値チェック
            const isMinus: boolean = /-/.test(this.agriFieldArea.toString())
            const integer: string = this.agriFieldArea.toString().split('.')[0]
            const decimal: string = this.agriFieldArea.toString().split('.')[1]
            if(isMinus || integer.length > 10 || decimal && decimal.length > 10) {
                errmsg.push("面積は0以上の整数部10桁小数部10桁までの数値を入力してください")
            }
        }
        // 表示日付
        if(moment(this.agriFieldDisplayStart).isAfter(moment(this.agriFieldDisplayEnd))) {
            errmsg.push("表示開始日は表示終了日以前で設定してください")
        }
        // メモ
        if(this.agriFieldMemo && this.agriFieldMemo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.agriFieldMemo.length}文字）`)
        }

        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }

        if(this.agriFieldPlantings) {
            this.agriFieldPlantings.forEach(item => {
                this.selectedPlantingIds.push(item.id)
            })
        }

        const selectedFiles = this.images.concat(this.files)

        const params: AgriFieldParam = {
            'name' : this.agriFieldName,
            'planted_area' : this.agriFieldArea ? this.agriFieldArea : 0,
            'memo' : this.agriFieldMemo,
            'display_start' : this.agriFieldDisplayStart,
            'display_end' : this.agriFieldDisplayEnd,
            'plantings': this.selectedPlantingIds,
            'is_hidden': this.agriFieldIdIsHidden
        }
        this.isLoading = true
        if(this.agriFieldId == 'create') {
            this.$apiClient.doRequest('post', this.apiBaseAdminUrl, params).then(ret => {
                if(selectedFiles){
                    const promise: any = []
                    for(const item of selectedFiles) {
                        promise.push(this.$apiClient.fileUpload(`${this.apiBaseAdminUrl}/${ret.id}/files`, item.file))
                    }
                    Promise.all(promise).finally(() => {this.getAgriFields()})
                }
                this.$router.push(this.clientBaseUrl + '/' + ret.id, () => {return})
                this.getAgriFields()
                this.$toasted.success('変更を保存しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
        } else if(this.agriFieldId) {
            const result = isHiddenUpdate ? true : window.confirm("内容を上書きして保存します。よろしいですか。")
            if(!result) {
                this.isLoading = false
                return false;
            }
            this.$apiClient.doRequest('put', `${this.apiBaseAdminUrl}/${this.agriFieldId}`, params).then((ret) => {
                const promise: any = []
                if(selectedFiles) {
                    const uploadFiles = selectedFiles.filter((file: File) => !file.id)
                    for(const item of uploadFiles) {
                        promise.push(this.$apiClient.fileUpload(`${this.apiBaseAdminUrl}/${ret.id}/files`, item.file))
                    }
                }
                this.deletedFiles.forEach(file => {
                    promise.push(this.$apiClient.doRequest('delete', `${this.apiBaseAdminUrl}/${this.agriFieldId}/files/${file.id}`))
                })
                Promise.all(promise).then(() => {
                    this.getAgriFields()
                    this.deletedFiles = []
                    this.$toasted.success('変更を保存しました。')
                })
            })
            .catch(error => {
                this.$toasted.error('変更に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
        } else {
            this.isLoading = false
        }
        this.selectedPlantingIds = []
        this.$store.dispatch('doUpdateIsInputChanged', false);
    }

    private checkDecimalPoint() {
        const splitedDecimalPoint = this.agriFieldArea.toString().split('.')
        if(splitedDecimalPoint[1] && splitedDecimalPoint[1].length > 10) {
            this.agriFieldArea = parseInt(splitedDecimalPoint[0])
        }
    }

    @Emit('inputChanged')
    inputChanged(){
        if(store.getters.isInputChanged==false){
            this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }
}

